import {Project} from "../../domain/project"

export interface IProjectsApi {
  getProjects(signal?: AbortSignal): Promise<Project[]>
  saveProject(project: Project): Promise<string>
}

export class ProjectsApi implements IProjectsApi {
  constructor(private baseUrl: string) {
  }

  async getProjects(signal?: AbortSignal): Promise<Project[]> {
    const url = `${this.baseUrl}/projects`
    const response = await fetch(url, {method: "get", signal})
    const projects = await response.json()
    projects.forEach((x: {dateStart: string | Date, dateUntil: string | Date | undefined }) => {
      x.dateStart = new Date(x.dateStart)
      if (x.dateUntil !== undefined) x.dateUntil = new Date(x.dateUntil)
    })
    return projects
  }

  async saveProject(project: Project): Promise<string> {
    const url = `${this.baseUrl}/projects`
    const response = await fetch(url, {
      method: project.id === undefined ? "post": "put",
      body: JSON.stringify(project),
      headers: {"Content-Type": "application/json"}
    })
    return await response.json() as string
  }
}
